import axios from "axios";
import { axiosInstance } from '../lib/api/index';
import { ApiResponseType } from '../lib/api/api';

export const getMaskedEmailByMobile = async (mobile: string): Promise<ApiResponseType> => {
  const { data: responseData } =  await axiosInstance.get(`/org/getEmailByMobile/${mobile}`);
  return responseData as ApiResponseType;
};

export const verifyEmail = async (mobile: string, email: string): Promise<void> => {
  await axiosInstance.post(`/org/verifyEmail/${mobile}/${email}`);
};

export const validateToken = async (token: string): Promise<void> => {
  await axiosInstance.get(`/org/validate-reset-token`, {
    params: { token },
  });
};

export const resetPassword = async (token: string, newPassword: string): Promise<void> => {
  await axiosInstance.post(`/org/reset-password`, null, {
    params: { token, newPassword },
  });
};
